import MarketSubheader from './components/TopHomePage/TopHomePage'
import MarketContent from './MarketContent'

const Markets = () => (
  <div className="w-full">
    <MarketSubheader />
    <MarketContent />
  </div>
)

export default Markets
